import { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import moment from "moment"
import { find } from "lodash"
import { DATE, CHART_ITEM } from "helpers/shapes"
import resizable from "hocs/resizable"
import tooltipContainer from "hocs/tooltip-container"
import Tooltip from "components/charts/tooltip"
import { BACKGROUND_RECT, HIGHLIGHTER, MARK } from "../shapes"
import Dot from "../dot"
import { HEIGHT, getGraphLines, getBackgroundRect, getDotScaleX, getScaleY, getHighlighter, getTopMark, getBottomMark } from "./helper"
import "./style.scss"

class StackedLineChart extends Component {
  static propTypes = {
    tooltip: PropTypes.element.isRequired,
    backgroundRect: BACKGROUND_RECT.isRequired,
    highlighter: HIGHLIGHTER,
    topMark: MARK.isRequired,
    bottomMark: MARK.isRequired,
    graphLines: PropTypes.shape({
      idioPath: PropTypes.string,
      factorsPath: PropTypes.string,
      transform: PropTypes.string.isRequired,
    }),
    scaleX: PropTypes.func.isRequired,
    scaleY: PropTypes.func.isRequired,
    data: PropTypes.arrayOf(CHART_ITEM).isRequired,
    width: PropTypes.number,
    startDate: DATE,
    endDate: DATE,
    date: DATE,
    setDate: PropTypes.func.isRequired,
    resizableRef: PropTypes.func.isRequired,
    subscribe: PropTypes.func.isRequired,
    unsubscribe: PropTypes.func.isRequired,
  }

  findByOffset = offset => {
    const { data, scaleX } = this.props
    const lookup = scaleX.invert(offset - 1) // -1 is to give a margin of selection on the first element
    return find(data, datum => datum.date >= lookup)
  }

  setDate = offset => {
    const { setDate, startDate, endDate } = this.props
    if (startDate !== endDate) {
      const { date } = this.findByOffset(offset)
      setDate(moment(date).format("YYYY-MM-DD"))
    }
  }

  handleGraphClick = ev => {
    const box = ev.currentTarget.getBoundingClientRect()
    const offsetX = ev.pageX - box.left
    this.setDate(offsetX)
  }

  findDotCoordinates = offset => {
    const { scaleX, scaleY } = this.props
    const datum = this.findByOffset(offset)

    if (datum) {
      return {
        cx: scaleX(datum.date),
        cy: scaleY(datum.value),
      }
    } else {
      return null
    }
  }

  render() {
    const { tooltip, subscribe, unsubscribe, resizableRef, backgroundRect, graphLines: { factorsPath, idioPath, transform }, data, highlighter, topMark, bottomMark } = this.props
    if (!data.length) {
      return <div ref={resizableRef}>No Data</div>
    } else {
      return <div ref={resizableRef}>
        <svg style={{ height: HEIGHT }} className="components_charts_stacked-line-chart">
          <rect {...backgroundRect} />
          <g transform={transform} className="stacked-line-background">
            <path className="factors" d={factorsPath} />
            <path className="idiosyncratic" d={idioPath} />
            <Dot {...{ subscribe, unsubscribe, findDotCoordinates: this.findDotCoordinates }} />
          </g>
          <rect {...backgroundRect} className="stacked-line-clickable" onClick={this.handleGraphClick} />
          {highlighter && <line className="highlighter" {...highlighter} />}
          <text {...topMark} dy="1rem">100%</text>
          <text {...bottomMark} dy="-2px">0</text>
        </svg>
        <Tooltip {...{ subscribe, unsubscribe, findByOffset: this.findByOffset }}>
          {tooltip}
        </Tooltip>
      </div>
    }
  }
}

const mapStateToProps = (state, props) => ({
  graphLines: getGraphLines(props),
  backgroundRect: getBackgroundRect(props),
  topMark: getTopMark(props),
  bottomMark: getBottomMark(props),
  scaleX: getDotScaleX(props),
  scaleY: getScaleY(props),
  highlighter: getHighlighter(props),
})

export default tooltipContainer(resizable(connect(mapStateToProps)(StackedLineChart)))
